import {useState,useContext} from 'react';
import Modal from '../Settings/Modal';
import { SettingModal, useSettingModal } from '../../../hooks/Context';
import styled from '@emotion/styled';
import { TopDisplay,Button,UploadButton } from '../../../ui-components';
import apiCall from '../../../utils/apiCall';
import { NotificationContext } from '../../../providers/notification';
import DisplayInterview from './DisplayInterview';
import apiCallFormData from '../../../utils/apiFormDataCall';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ExNyRoute } from '../../../utils/allRouteId';

export default function Interview() {

  const [route, setRoute] = useState<{name: string, val: number}>({name: 'Examination / NYSC', val: Number(ExNyRoute)})
  const [openReInviteModal, setOpenReInviteModal] = useState(false);


  const handleOpenReInvite = () => {
    setOpenReInviteModal(true)
  }

  const handleCloseReInvite = () => {
    setOpenReInviteModal(false)
  }

  return (

      <SettingModal>
        <ViewWrapper>
                <TopDisplay subTitle={` All / Pending Invites` }title="Interviews" Btn={<TopBtns handleOpenReInvite= {handleOpenReInvite} id={route?.val}/>} />
                <DisplayInterview showReinviteModal= {openReInviteModal} handleCloseReinvite = {handleCloseReInvite} route= {route} setRoute = {setRoute}/>
        </ViewWrapper>
        <Modal />
      </SettingModal>
  )
}

 const TopBtns = (props:any)=>{
  const {setModalContent,setShowModal} = useSettingModal();
  const {showNotification} = useContext(NotificationContext);
  const [u_loading,set_u_loading] = useState<boolean>(false);

  const routeId = props.id || 1;
  const handleOpenReInvite = props.handleOpenReInvite;

  const handleReInvite = () =>{
    //setModalContent(<ReInvites />)
    handleOpenReInvite()
  }
  

  const downloadPendingInterview = async () => {
    return await (apiCall().get(`/Activity/DownloadPendingInterview?&activity=Interview`, {responseType: 'blob'}))
  }

  const { data, isSuccess, error, refetch, isLoading, isFetching } = useQuery(['download-applicant-pending-Interview', routeId], downloadPendingInterview, {
    retry: 0,
    keepPreviousData: true,
    enabled: false,
  });

  const downloadPendingInterviewError = error as AxiosError;
  const downloadApplicantPendingInterviewErrorMessage = downloadPendingInterviewError?.message;

  const handleDownloadPendingInterview = async () => {
    
    await refetch().then((data: any) => {
      if(!data) return
    
      const blob = new Blob([data?.data?.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
      if (isSuccess) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'InterviewList.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
      showNotification({
        type: 'error',
        message: 'No record found for download',
      })
    }
    })
  };

  const uploadInterviewAttendant = async(data: FormData) => {
    return await(apiCallFormData().post('/Activity/UploadInterviewAttendant', data));
  }

  const uploadInterviewAttendantMutation = useMutation(['upload-interview-attendant'], uploadInterviewAttendant, {retry: 0});
  
  const handleUpload =  async (e:any) => {
    let file = e.target.files[0];
    let activity = "Interview";

    const body = new FormData();
    body.append('ApplicantFile', file);

    set_u_loading(true);
    try {
      await uploadInterviewAttendantMutation.mutateAsync(body, {
        onSuccess: () => {
          showNotification({
            message:'file uploaded successfully',
            type:'success'
          })
          set_u_loading(false);
        },
        onError: () => {
          set_u_loading(false);
        }
      })
      
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error?.message || 'file not uploaded ',
        type:'error'
      })
    }
  }

  return (<div style={{display:'flex',gap:'10px'}}>
    <UploadButton onChange={handleUpload} label={!u_loading?"Upload Interview List":'Loading Upload...' }/>

    <Button onClick={handleDownloadPendingInterview} children={!isFetching ? 'Download' : 'Downloading...'} border="#E2E4E9" bg="#E2E4E9" color="#11643C"/>
    <Button onClick={handleReInvite} children={'Re Invite'}  />

  </div>)
}

const ViewWrapper = styled.div`
  width: 100%;
  padding:0 48px 48px;
`


